import { useEffect, useState } from "react";
import Button from "../../../../Custom/Button/Button";
import { useGlobalContext } from "../../../../../Context/Context";
import TabelaZaposleni from "./TabelaZaposleni";

const styles = {
  button: { width: "15vw", height: "40px" },
};

function Evidencije6() {
  // "AKTIVNI"/"DODATNI"/"ARHIVIRANI"
  const [currentTab, setCurrentTab] = useState("AKTIVNI");

  const { dictionary } = useGlobalContext();

  return (
    <div
      style={{
        fontSize: "14px",
        height: "100%",
        width: "100%",
        display: "flex",
      flexDirection: "column",
      justifyContent: "space-between"
      }}
    >
      <div
        style={{
          display: "flex",
          gap: "10px",
          marginBottom: "20px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
            height: "10%"

          }}
        >
          <div>
            <div onClick={() => setCurrentTab("AKTIVNI")} style={styles.button}>
              <Button activation={true} active={currentTab === "AKTIVNI"}>
                <span style={{fontWeight: "bold"}}>{dictionary["aktivniZaposleni"]}</span>
              </Button>
            </div>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              gap: "5px"
            }}
          >
            <div onClick={() => setCurrentTab("DODATNI")} style={styles.button}>
              <Button activation={true} active={currentTab === "DODATNI"}>
                <span style={{fontWeight: "bold"}}>{dictionary["dodatniPoslovi"]}</span>
              </Button>
            </div>
            <div
              onClick={() => setCurrentTab("ARHIVIRANI")}
              style={styles.button}
            >
              <Button activation={true} active={currentTab === "ARHIVIRANI"}>
                <span style={{fontWeight: "bold"}}>{dictionary["arhiviraniZaposleni"]}</span>
              </Button>
            </div>
          </div>
          
        </div>
      </div>

      <TabelaZaposleni currentTab={currentTab} />
    </div>
  );
}

export default Evidencije6;
